/* @flow */

import { assertObject, assertHTMLElement } from '@e180/util/lib/assert';

import type { ReactObjRef } from 'src/shared/core/type/reactTypes';

/**
 * Get the count of lines of a HTML element
 * @param  {elt} elt - Element to get the count from
 * @return {number} Count of lines
 */
export function getElementLineCount(elt: HTMLElement): number {
  assertHTMLElement(elt, 'elt');

  const style = window.getComputedStyle(elt);

  let { lineHeight, paddingTop, paddingBottom } = style;

  lineHeight = parseInt(lineHeight, 10);
  paddingTop = parseInt(paddingTop, 10);
  paddingBottom = parseInt(paddingBottom, 10);

  if (lineHeight) {
    const { height } = elt.getBoundingClientRect();

    return Math.round((height - paddingTop - paddingBottom) / lineHeight);
  }

  return 0;
}

export function getFocusableChildren(
  parent: HTMLElement,
): NodeList<HTMLElement> {
  assertHTMLElement(parent, 'parent');

  return parent.querySelectorAll(
    'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
  );
}

export function getFirstFocusableChild(parent: HTMLElement): ?HTMLElement {
  assertHTMLElement(parent, 'parent');

  const children = getFocusableChildren(parent);
  const { length } = children;

  if (length > 0) {
    return children[0];
  }
}

export function focusFirstRefChild(ref: ReactObjRef<any>): void {
  assertObject(ref, 'ref');

  const { current: elt } = ref;

  if (elt instanceof HTMLElement) {
    const focusableElt = getFirstFocusableChild(elt);

    if (focusableElt) {
      focusableElt.focus();
    }
  }
}
